module.exports = __webpack_public_path__ + "static/media/bin.5e115c9c.svg";